import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/CartContext";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import CartPage from "@/pages/Cart";
import Story from "@/pages/Story";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Account from "@/pages/Account";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import EarlyAccess from "@/pages/EarlyAccess";
import Ingredients from "@/pages/Ingredients";
import IngredientDetail from "@/pages/IngredientDetail";
import Invest from "@/pages/Invest";
import Feedback from "@/pages/Feedback";
import Invite from "@/pages/Invite";
import Privacy from "@/pages/Privacy";
import MobileTerms from "@/pages/MobileTerms";
import CookieSettings from "@/pages/CookieSettings";
import { AnalyticsConsent } from "@/components/privacy/AnalyticsConsent";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AnnouncementBar from "@/components/AnnouncementBar";
import PublicLayout from "@/components/PublicLayout";
import ScrollToTop from "@/components/ScrollToTop";

function PreviewShell({ children }) {
  return (
    <>
      <AnnouncementBar />
      <Navbar />
      <main data-testid="site-main">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[color:var(--bg)] text-[color:var(--ink)]">
      <BrowserRouter>
        <ScrollToTop />
        <CartProvider>
          <Routes>
            {/* Public: early access landing */}
            <Route path="/" element={<EarlyAccess />} />
            <Route path="/early-access" element={<EarlyAccess />} />

            {/* Public: content pages accessible from the early access CTAs */}
            <Route path="/story" element={<PublicLayout><Story /></PublicLayout>} />
            <Route path="/journal" element={<PublicLayout><Journal /></PublicLayout>} />
            <Route path="/journal/:slug" element={<PublicLayout><JournalPost /></PublicLayout>} />
            <Route path="/ingredients" element={<PublicLayout><Ingredients /></PublicLayout>} />
            <Route path="/ingredients/:slug" element={<PublicLayout><IngredientDetail /></PublicLayout>} />
            <Route path="/invest" element={<Invest />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/invite" element={<Invite />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/legal/privacy" element={<Privacy />} />
            <Route path="/mobile-terms" element={<MobileTerms />} />
            <Route path="/legal/mobile-terms" element={<MobileTerms />} />
            <Route path="/cookie-settings" element={<CookieSettings />} />

            {/* Private: full store under /preview (not linked publicly) */}
            <Route path="/preview" element={<PreviewShell><Home /></PreviewShell>} />
            <Route path="/preview/shop" element={<PreviewShell><Shop /></PreviewShell>} />
            <Route path="/preview/product/:handle" element={<PreviewShell><Product /></PreviewShell>} />
            <Route path="/preview/cart" element={<PreviewShell><CartPage /></PreviewShell>} />
            <Route path="/preview/account" element={<PreviewShell><Account /></PreviewShell>} />
            <Route path="/preview/checkout/success" element={<PreviewShell><CheckoutSuccess /></PreviewShell>} />

            {/* Fallback: any unknown route → early access */}
            <Route path="*" element={<EarlyAccess />} />
          </Routes>
          <Toaster position="top-center" />
          <AnalyticsConsent />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
